var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "section",
      [
        _c(
          "el-dialog",
          {
            staticClass: "create_dialog",
            attrs: {
              "before-close": _vm.handleClose,
              visible: _vm.isOpen,
              "show-close": true,
              width: "25%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.isOpen = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c("div", { staticClass: "title_dialog" }, [
                      _c("span", [_vm._v("Chỉnh sửa thẻ")]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _c(
              "el-form",
              {
                ref: "defaultDataTag",
                attrs: { model: _vm.defaultDataTag, rules: _vm.validation },
              },
              [
                _c(
                  "section",
                  { staticClass: "dialog_body" },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c(
                            "div",
                            { staticClass: "wrapper_input" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Tên emotion: ",
                                    prop: "title",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "Nhập tiêu đề",
                                      "prefix-icon": "el-icon-edit",
                                      type: "textarea",
                                    },
                                    model: {
                                      value: _vm.defaultDataTag.title,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.defaultDataTag,
                                          "title",
                                          $$v
                                        )
                                      },
                                      expression: "defaultDataTag.title",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "wrapper_input",
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center",
                              },
                            },
                            [
                              _c("el-color-picker", {
                                attrs: {
                                  predefine: _vm.colorText(),
                                  "color-format": "hex",
                                },
                                model: {
                                  value: _vm.defaultDataTag.color,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.defaultDataTag, "color", $$v)
                                  },
                                  expression: "defaultDataTag.color",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "section",
              { attrs: { slot: "footer" }, slot: "footer" },
              [
                _c("hr"),
                _c(
                  "el-button",
                  {
                    attrs: { icon: "el-icon-circle-close", type: "danger" },
                    on: { click: _vm.handleClose },
                  },
                  [_vm._v("\n          Hủy bỏ\n        ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "success",
                      icon: "el-icon-circle-check",
                      loading: _vm.isLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleSaveForm()
                      },
                    },
                  },
                  [_vm._v("\n          Lưu\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }